import { useRef } from "react";
import { useIbkrData, useVisible } from "./poller";
import { QuoteRow } from "./types";
import { C, Chip, IconButton, WidgetBox, companyName, fmt, freshnessDot } from "./ui";
import { WidgetProps, openLadder, openLimit, referencePrice } from "./windows";

// live bid / last / ask of one contract; params {conId}
export function QuoteWidget({ widget, actions }: WidgetProps) {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useVisible(ref);
  const { data, freshness } = useIbkrData<QuoteRow[]>("quotes", { conIds: [widget.params.conId] }, visible);
  const row = data?.[0];
  const ok = row && "contract" in row ? row : undefined;

  const cell = (label: string, value: number | null | undefined, bold = false) => (
    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <span style={{ color: C.muted }}>{label}</span>
      <span style={{ fontSize: 20, fontWeight: bold ? 600 : 400 }}>{fmt(value)}</span>
    </div>
  );

  return (
    <WidgetBox
      boxRef={ref}
      title={<span><Chip>{ok?.contract.label ?? "…"}</Chip> {companyName(ok?.contract)}</span>}
      status={row && "error" in row ? <span style={{ color: C.cancelled }}>{row.error}</span> : freshnessDot(freshness, ok?.quote.dataType)}
      onDuplicate={() => actions.duplicate({ ...widget.params })}
      onClose={actions.close}
    >
      <div style={{ display: "flex", alignItems: "flex-end", gap: 8, padding: "10px 10px 12px" }}>
        {cell("Bid:", ok?.quote.bid)}
        {cell("Last:", ok?.quote.last, true)}
        {cell("Ask:", ok?.quote.ask)}
        <div style={{ flex: "none", display: "flex", gap: 6 }}>
          <IconButton icon="ladder" label={`Open ladder buy / sell for ${ok?.contract.label ?? ""}`} title="Ladder buy / sell"
            disabled={!ok} onClick={() => ok && openLadder(actions, ok.contract)} />
          <IconButton icon="plus" label={`Open limit order for ${ok?.contract.label ?? ""}`} title="Limit order" iconSize={16}
            disabled={!ok} onClick={() => ok && openLimit(actions, ok.contract, referencePrice(ok.quote))} />
        </div>
      </div>
    </WidgetBox>
  );
}
